const meat = [
    {
        id: "beefMince",
        name: "Mince (Beef)",
    },
    {
        id: "porkMince",
        name: "Mince (Pork)",
    },
    {
        id: "steak",
        name: "Steak",
    },
    {
        id: "chickenBreast",
        name: "Chicken (Breast)",
    },
    {
        id: "chickenThigh",
        name: "Chicken (Thigh)",
    },
    {
        id: "chickenWhole",
        name: "Chicken (Whole)",
    },
];

const vegetables = [
    {
        id: "broccoli",
        name: "Broccoli",
    },
    {
        id: "carrot",
        name: "Carrot",
    },
    {
        id: "cauliflower",
        name: "Cauliflower",
    },
    {
        id: "capsicum",
        name: "Capsicum",
    },
    {
        id: "potato",
        name: "Potato",
    },
    {
        id: "mushroom",
        name: "Mushroom",
    },
    {
        id: "onion",
        name: "Onion",
    },
    {
        id: "garlic",
        name: "Garlic",
    },
    {
        id: "ginger",
        name: "Ginger",
    },
];

const staples = [
    {
        id: "rice",
        name: "Rice",
    },
    {
        id: "pasta",
        name: "Pasta",
    },
    {
        id: "riceNoodles",
        name: "Rice Noodles",
    },
    {
        id: "eggNoodles",
        name: "Egg Noodles",
    },
    {
        id: "bread",
        name: "Bread",
    },
    {
        id: "wraps",
        name: "Wraps",
    },
];

const sauces = [
    {
        id: "soy",
        name: "Soy",
    },
    {
        id: "gochujang",
        name: "Gochujang",
    },
    {
        id: "oyster",
        name: "Oyster",
    },
    {
        id: "hoisin",
        name: "Hoisin",
    },
    {
        id: "sweetChilli",
        name: "Sweet Chilli",
    },
    {
        id: "sriracha",
        name: "Sriracha",
    },
    {
        id: "whiteWineVinegar",
        name: "White Wine Vinegar",
    },
    {
        id: "appleCiderVinegar",
        name: "Apple Cider Vinegar",
    },
    {
        id: "fishSauce",
        name: "Fish Sauce",
    },
    {
        id: "sesameOil",
        name: "Sesame Oil",
    },
    {
        id: "chineseCookingWine",
        name: "Chinese Cooking Wine",
    },
];

const other = [
    {
        id: "honey",
        name: "Honey",
    },
];

const dairy = [
    {
        id: "milk",
        name: "Milk",
    },
    {
        id: "cream",
        name: "Cream",
    },
    {
        id: "cheddarCheese",
        name: "Cheese (Cheddar)",
    },
    {
        id: "yoghurt",
        name: "Yoghurt (Greek)",
    },
    {
        id: "coconutCream",
        name: "Coconut Cream",
    },
];

const ingredients = [
    {
        title: "Meat",
        items: meat,
    },
    {
        title: "Vegetables",
        items: vegetables,
    },
    {
        title: "Staples",
        items: staples,
    },
    {
        title: "Sauces",
        items: sauces,
    },
    {
        title: "Dairy",
        items: dairy,
    },
    {
        title: "Other",
        items: other,
    },
];

export { ingredients };
